const initialState = {
  editingEmployee: {},
};

const Employee = (state = initialState, action) => {
  switch (action.type) {
    case 'EDIT_EMPLOYEE':
      return {
        ...state,
        editingEmployee: action.data,
      };
    default:
      return state;
  }
};
export default Employee;
